import { observer } from "mobx-react-lite"
import { context } from "../.."
import PreviousAnswers from "./PreviousAnswers"
import { Button } from "@mui/material"
import React from "react"
import { format } from 'date-fns'
import { pdfCreate, PdfDocLine } from '../../misc/pdf'


export default observer(function PageFinal () {
    
    const { locked, submitting } = context
    const [submittingPdg, setSubmittingPdf] = React.useState(false)

    React.useEffect(() => {
        // This is needed to refresh the uploads list
        // loadQuestionnaire()
    }, [])

    var completedAt = format(new Date(), "yyyy-MM-dd HH:ii:ss")

    var pdfDocumentJson: PdfDocLine[] = [
        {type: "h1", content: `${context.questionnaire.template.displayName}: ${context.questionnaire.displayName}`, orderInd: 0},
        {type: "field-value", content: "", orderInd: 1},
        {type: "field-value", content: `Adviser email: ${context.questionnaire.notificationEmail}`, orderInd: 2},
        {type: "field-value", content: `Applicant email: ${context.questionnaire.respondent.respondentEmail}`, orderInd: 3},
        {type: "field-value", content: `Link: ${context.questionnaire.link}`, orderInd: 4},
        {type: "field-value", content: `Questionnaire template: ${context.questionnaire.template.key} ${context.questionnaire.template.version}`, orderInd: 5},
        {type: "field-value", content: `Created at: ${format(new Date(context.questionnaire.createdAt), "yyyy-MM-dd HH:ii:ss")}`, orderInd: 7},
        {type: "field-value", content: `Completed at: ${completedAt}`, orderInd: 8},
    ]

    const generateAndUploadPdf = async () => {

        setSubmittingPdf(true)

        var fileName = `Questionnaire review ${completedAt} - ${context.questionnaire.displayName}.pdf`
        var pdfBlob = await pdfCreate(pdfDocumentJson, context.advisorAccount.logoUri)

        if (pdfBlob != null) {
            var file = new File([pdfBlob], fileName)
            var upload = await context.uploadFile(null, file, "questionnaire_review")
            console.log(upload)
        }

        setSubmittingPdf(false)
    }

    return (
        <div className="questionnaire-page">
            <div>
                <h1>Check your answers</h1>

                <p>Thank you for completing this questionnaire. </p>

                {locked 
                    ? <p>This questionnaire is locked.</p>
                    : <p>Please check all answers before submitting. Once submitted, you will no longer be able to edit, and the information will be sent to your Legal Adviser.</p>
                }
            </div>

            {/* {uploads?.length ? (
                <div>
                    <h2>Attachments</h2>
                    <Uploads />
                </div>
            ) : null} */}

            <PreviousAnswers writePdf={(lineObject: PdfDocLine) => {
                pdfDocumentJson.push(lineObject)
            }} />

            <Button 
                className="btn btn-lg" 
                color="success" 
                variant="contained" 
                disabled={submittingPdg || submitting || locked} 
                onClick={async () => {
                    await generateAndUploadPdf()
                    await context.submitQuestionnaire()
                }}>
                Confirm answers and Submit
            </Button>
        </div>
    )
})